import { useState, useEffect } from 'react';
import IconManager from './IconManager';
import StyleManager from './StyleManager';
import ButtonManager from './ButtonManager';

function useButtonState({
  icon,
  iconHover,
  iconDisabled,
  iconLoading,
  iconLoadingHover,
  color,
  backgroundColor,
  borderColor,
  colorHover,
  backgroundColorHover,
  borderColorHover,
  isActive,
  isHover,
  loading,
  disableOnClick,
  loadingOnClick,
  disabled,
  clicked
}) {
  const [style, setStyle] = useState(null);
  const [showTag, setShowTag] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const [reactIcon, setReactIcon] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const iconManager = new IconManager({
      icon,
      iconHover,
      iconDisabled,
      iconLoading,
      iconLoadingHover
    });

    const styleManager = new StyleManager({
      color,
      backgroundColor,
      borderColor,
      colorHover,
      backgroundColorHover,
      borderColorHover
    });

    const buttonManager = new ButtonManager({
      iconManager,
      styleManager
    });

    const reactIcon = buttonManager.getReactIcon({
      isHover,
      loadingOnClick,
      disableOnClick,
      loading,
      disabled,
      clicked
    });

    const style = buttonManager.getStyle({ isActive });
    const showTag = buttonManager.shouldShowTag({ loadingOnClick, clicked });
    const showIcon = buttonManager.shouldShowIcon({ loadingOnClick, clicked });
    const isDisabled = iconManager.isDisabled({ disabled, disableOnClick, clicked });

    setStyle(style);
    setShowTag(showTag);
    setShowIcon(showIcon);
    setReactIcon(reactIcon);
    setIsDisabled(isDisabled);
  }, [
    backgroundColor,
    backgroundColorHover,
    borderColor,
    borderColorHover,
    clicked,
    color,
    colorHover,
    disableOnClick,
    disabled,
    icon,
    iconDisabled,
    iconHover,
    iconLoading,
    iconLoadingHover,
    isActive,
    isHover,
    loading,
    loadingOnClick
  ]);

  return { style, showTag, showIcon, reactIcon, isDisabled };
}

export default useButtonState;
